'use strict';

var _ = require('lodash');
var SponsorshipPanelController = function SponsorshipPanelController($scope, ScheduleChangeConstants) {
  $scope.uniqueId = 'sponsor-chart-' + Math.random().toString().substr(2);
  $scope.selectedSponsor = null;
  $scope.copyDemandPercent = 100;
  $scope.isValueCommitted = false;
  $scope.sponsorshipTitle = 'Market';
  $scope.maxlength = 'Allowed value range is 1-999';
  if ($scope.wizardShown === ScheduleChangeConstants.ENTITIES.LEGS) {
    $scope.sponsorshipTitle = 'Leg';
  }
  $scope.setSponsor = function () {
    if ($scope.selectedSponsor) {
      $scope.pos.sponsor = $scope.selectedSponsor;
      $scope.pos.sponsor.sponsorDemandPercentageCopy = $scope.copyDemandPercent;
      $scope.isValueCommitted = true;
      $scope.collapse();
    }
  };
  $scope.resetSponsor = function () {
    $scope.pos.sponsor = undefined;
    $scope.isValueCommitted = false;
    $scope.resetForm();
  };
  $scope.$watch('pos.sponsor', function () {
    if ($scope.pos.sponsor !== undefined) {
      $scope.selectedSponsor = $scope.pos.sponsor;
      if (!_.isUndefined($scope.pos.sponsor.sponsorDemandPercentageCopy)) {
        $scope.copyDemandPercent = $scope.pos.sponsor.sponsorDemandPercentageCopy;
      }
      $scope.setSponsor();
    }
  });
  $scope.shouldShowPercentageCopy = function () {
    return $scope.sponsorshipTitle === 'Leg' ? false : true;
  };
};
SponsorshipPanelController.$inject = ['$scope', 'ScheduleChangeConstants'];
module.exports = SponsorshipPanelController;